import { Student } from '../../../shared-components/student/student.model';
import { FreeReducedMealAppAdult } from './free-reduced-meal-app-adult.model';
import { FreeReducedMealAppChild } from './free-reduced-meal-app-child.model';
import { FreeReducedMealAppCompletedPage } from './free-reduced-meal-app-completed-pages.model';
import { FreeReducedMealAppHouseholdProgram } from './free-reduced-meal-app-household-program.model';
import { FreeReducedMealAppInfoSharing } from './free-reduced-meal-app-info-sharing.model';

export class FreeReducedMealApp {
    ID: number;
    YearID: number;
    FamilyID: number;
    FamilyLanguageId: number;
    Status: string ;
    CreatedDate: Date;
    CreatedBy: number;
    CreatedByName: string;
    SubmittedBy: number;
    SubmittedDate: Date;
    SubmittedByName: string;
    SubmittedByEmail: string;
    SignedBy: number;
    SignedByName: string;
    SignedDate: Date;
    CertifiedBy: number;
    CertifiedDate: Date;
    CertifiedByName: string;
    ParentName: string;
    PrimaryParentFirstName: string;
    PrimaryParentLastName: string;
    PrimaryParentSuffixId: number;
    LastFourSSN: string;
    NoSSN: boolean;
    ShareInfo: boolean;
    Children: FreeReducedMealAppChild[];
    Adults: FreeReducedMealAppAdult[];
    Programs: FreeReducedMealAppHouseholdProgram[];
    InfoSharing: FreeReducedMealAppInfoSharing[];
    CompletedPages: FreeReducedMealAppCompletedPage[];
    Note: string;
    ApplicationAsPDF: string;
    Students: Student[] = [];
    SendMailingsInSpanish: boolean;
    TimesAccepted: number;
    LastAcceptedByName: string;

    constructor(yearId: number, familyId: number) {
        this.YearID = yearId;
        this.FamilyID = familyId;
        this.Status = 'not submitted';
        this.Children = [];
        this.Adults = [];
        this.Programs = [];
        this.InfoSharing = [];
        this.CompletedPages = [];
    }
   }

